import $ from "jquery";
function clampPercent(p) {
    if (isNaN(p))
        return 0;
    if (p < 0)
        return 0;
    if (p > 100)
        return 100;
    return Math.floor(p);
}
function setUiProgress(options, pct, text) {
    var percent = clampPercent(pct);
    var barSel = options.progressBarSelector || "#uploadProgressBar";
    var statusSel = options.statusSelector || "#uploadStatus";
    var $bar = $(barSel);
    if ($bar.length) {
        $bar.css("width", percent + "%");
        $bar.attr("aria-valuenow", percent.toString());
        $bar.text(text ? text : (percent + "%"));
    }
    if (text) {
        var $status = $(statusSel);
        if ($status.length)
            $status.text(text);
    }
}
function formatUrl(tpl, uploadId) {
    return tpl.replace("{uploadId}", uploadId);
}
function xhrUploadChunk(url, formData, onProgress, onOk, onErr) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.upload.onprogress = function (ev) {
        if (ev && ev.lengthComputable) {
            onProgress(ev.loaded, ev.total);
        }
    };
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            onOk();
        }
        else {
            onErr(xhr.responseText || ("HTTP " + xhr.status));
        }
    };
    xhr.onerror = function () {
        onErr("Network error during upload.");
    };
    xhr.send(formData);
}
function indexOfNumber(arr, value) {
    // ES5-safe
    return arr.indexOf(value);
}
// Main entry
export function chunkUploadFileWithProgress(file, options, callbacks) {
    var opt = options || {};
    var initUrl = opt.initUrl || "/admin/uploads/init";
    var statusTpl = opt.statusUrlTemplate || "/admin/uploads/{uploadId}/status";
    var chunkTpl = opt.chunkUrlTemplate || "/admin/uploads/{uploadId}/chunk";
    var completeTpl = opt.completeUrlTemplate || "/admin/uploads/{uploadId}/complete";
    var fallbackChunkSize = opt.fallbackChunkSizeBytes || (10 * 1024 * 1024);
    function progress(p) {
        if (callbacks.onProgress)
            callbacks.onProgress(p);
        setUiProgress(opt, p);
    }
    function status(text) {
        if (callbacks.onStatus)
            callbacks.onStatus(text);
        // keep progress text unchanged unless provided
        setUiProgress(opt, NaN, text);
    }
    progress(0);
    status("Initializing...");
    // 1) init
    $.ajax({
        url: initUrl,
        method: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({
            fileName: file.name,
            fileSize: file.size,
            contentType: file.type
        })
    })
        .done(function (init) {
        var uploadId = init.uploadId;
        var chunkSize = init.chunkSize || fallbackChunkSize;
        var totalChunks = init.totalChunks;
        // 2) status (resume) - best-effort
        var statusUrl = formatUrl(statusTpl, uploadId);
        $.ajax({
            url: statusUrl,
            method: "GET"
        })
            .done(function (st) {
            var uploadedIndexes = (st && st.uploadedIndexes) ? st.uploadedIndexes : [];
            uploadAllChunks(uploadId, file, chunkSize, totalChunks, uploadedIndexes);
        })
            .fail(function () {
            uploadAllChunks(uploadId, file, chunkSize, totalChunks, []);
        });
        function uploadAllChunks(uploadId2, file2, chunkSize2, total2, uploaded) {
            var completed = uploaded.length;
            var i = 0;
            function overallPercent(currentChunkPct0to1) {
                var pct = ((completed + currentChunkPct0to1) / total2) * 100;
                return clampPercent(pct);
            }
            function skipAlreadyUploaded() {
                while (i < total2 && indexOfNumber(uploaded, i) !== -1) {
                    completed++;
                    progress((completed / total2) * 100);
                    i++;
                }
            }
            function next() {
                skipAlreadyUploaded();
                if (i >= total2) {
                    // 3) complete
                    progress(100);
                    status("Assembling on server...");
                    var completeUrl = formatUrl(completeTpl, uploadId2);
                    $.ajax({
                        url: completeUrl,
                        method: "POST"
                    })
                        .done(function (res) {
                        progress(100);
                        status("Done");
                        callbacks.onDone(res);
                    })
                        .fail(function (xhr) {
                        var msg = (xhr && xhr.responseText) ? xhr.responseText : "Complete failed";
                        callbacks.onError(msg);
                    });
                    return;
                }
                status("Uploading chunk " + (i + 1) + "/" + total2);
                var start = i * chunkSize2;
                var end = Math.min(file2.size, start + chunkSize2);
                var blob = file2.slice(start, end);
                var fd = new FormData();
                fd.append("index", i.toString());
                fd.append("totalChunks", total2.toString());
                fd.append("chunk", blob, file2.name + ".part");
                var chunkUrl = formatUrl(chunkTpl, uploadId2);
                xhrUploadChunk(chunkUrl, fd, function (loaded, totalBytes) {
                    var pct01 = 0;
                    if (totalBytes && totalBytes > 0)
                        pct01 = loaded / totalBytes;
                    progress(overallPercent(pct01));
                }, function () {
                    // done this chunk
                    completed++;
                    progress((completed / total2) * 100);
                    i++;
                    next();
                }, function (err) {
                    callbacks.onError("Chunk " + i + " failed: " + err);
                });
            }
            next();
        }
    })
        .fail(function (xhr) {
        var msg = (xhr && xhr.responseText) ? xhr.responseText : "Init failed";
        callbacks.onError(msg);
    });
}
// Convenience helper: run chunk upload and then fill your MVC hidden inputs
// (FileUrl, FileName, OriginalFileName) to be used in subsequent AJAX Save.
export function chunkUploadAndFillForDownloadFields(file, options, callbacks) {
    var fileUrlSel = callbacks.fileUrlSelector || "#FileUrl";
    var fileNameSel = callbacks.fileNameSelector || "#FileName";
    var origSel = callbacks.originalFileNameSelector || "#OriginalFileName";
    chunkUploadFileWithProgress(file, options, {
        onProgress: callbacks.onProgress,
        onStatus: callbacks.onStatus,
        onDone: function (res) {
            if (res && res.url)
                $(fileUrlSel).val(res.url);
            if (res && res.fileName)
                $(fileNameSel).val(res.fileName);
            var original = res.originalFileName;
            if (original && original.length) {
                $(origSel).val(original);
            }
            else if (res && res.fileName) {
                // fallback: keep something sensible
                $(origSel).val(file.name);
            }
            callbacks.onDone(res);
        },
        onError: callbacks.onError
    });
}
//# sourceMappingURL=upload.js.map